//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import Comment from './Comment.vue'

export default {
  components: {
    Comment
  },
  props: {
    comments: {
      type: Array,
      default () {
        return []
      }
    },
    contentLeft: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    hideAddBtn: {
      type: Boolean,
      default: false
    },
    fieldAutogrow: {
      type: Boolean,
      default: true
    },
    alwaysDisplayAllComments: {
      type: Boolean,
      default: false
    },
    editableUploaded: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      expandedPreviousComments: this.alwaysDisplayAllComments
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    _readonly: function () {
      return this.readonly || !this.comments
    },
    sortedComments: function () {
      // последний комментарий сверху (сортировка по убыванию даты)
      const sortedComments = JSON.parse(JSON.stringify(this.comments ? this.comments : []))
      sortedComments.sort((a, b) => b.time - a.time)
      // скрываем пустые
      return sortedComments.filter(comment => !!comment.comment)
    },
    previousComments: function () {
      const uploadedComments = this.sortedComments.filter(comment => !comment.notUploaded)
      if (uploadedComments.length) {
        return uploadedComments.slice(1, uploadedComments.length)
      }
      return []
    },
    lastComments: function () {
      const notUploadedComments = this.sortedComments.filter(comment => comment.notUploaded)
      const lastComments = [...notUploadedComments]

      const uploadedComments = this.sortedComments.filter(comment => !comment.notUploaded)
      if (uploadedComments.length) {
        // последний загруженный (сортировка по убыванию даты)
        lastComments.push(uploadedComments[0])
      }

      if (this.alwaysDisplayAllComments) {
        // последние комментарии не свёрнуты
        lastComments.push(...this.previousComments)
      }

      return lastComments
    }
  },
  methods: {
    onAddComment: function (callback) {
      this.$d_ask({
        callback: (data) => {
          this.addComment(data)
          this.$nextTick(() => {
            !!callback && callback()
          })
        },
        header: 'Добавление комментария',
        propsConfig: {
          comment: { type: 'text', label: 'Комментарий', required: true, autogrow: this.fieldAutogrow }
        },
        buttons: { yes: 'Добавить', cancel: 'Отмена' }
      })
    },
    addComment: function (comment) {
      if (this.user.name) {
        comment.fio = this.user.name
      }
      comment.user = this.user.login
      comment.time = new Date().getTime()
      comment.notUploaded = true
      comment.added = true
      this.comments.push(comment)
    },
    onDeleteComment: function (commentData) {
      const index = this.comments.findIndex(c => c.time === commentData.time)
      if (index !== -1) {
        if (commentData.notUploaded) {
          if (index !== -1) {
            this.comments.splice(index, 1)
          }
        } else {
          // Уже сохраненные оставляем для истории, но удаляем сам текст, чтобы скрылись
          this.comments[index].edited = true
          this.comments[index].comment = null
        }
      }
    },
    onEditComment: function (commentData) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const index = this.comments.findIndex(c => c.time === commentData.time)
            if (index !== -1) {
              if (commentData.notUploaded) {
                this.comments[index].comment = data.comment
              } else {
              // Уже сохраненные оставляем для истории, добавлем новый комментарий
                this.addComment(data)
              }
            }
          }
        },
        header: 'Редактирование комментария',
        propsConfig: {
          comment: { type: 'text', label: 'Комментарий', value: commentData.comment, autogrow: this.fieldAutogrow, required: true }
        },
        buttons: { yes: 'Применить', cancel: 'Отмена' }
      })
    }
  }
}
